interface ATDBasedMinimums {
    diMin: number;
    apdMin: number;
}

export function getATDBasedMinimums(atdValue: number): ATDBasedMinimums {
    if (atdValue <= 15) {
        return { diMin: 5000, apdMin: 20000 };
    }
    if (atdValue === 20) {
        return { diMin: 40000, apdMin: 50000 };
    }
    if (atdValue >= 30) {
        return { diMin: 40000, apdMin: 70000 };
    }
    return { diMin: 5000, apdMin: 20000 };
}
